import FuelDataModal from './FuelDataModal';
export default FuelDataModal;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/FuelDataModal/index.js